export const USERLIST = [
  {
    title: "所属部门",
    dataIndex: "depart",
    width: 180,
  },
  {
    title: "姓名",
    dataIndex: "name",
    width: 100,
  },
  {
    title: "职责",
    dataIndex: "duty",
    width: 280,
  },
  {
    title: "邮箱",
    dataIndex: "email",
    width: 200,
  },
  {
    title: "手机号",
    dataIndex: "phone",
    width: 130,
  },
];

export const OPENLIST = [
  {
    title: "所属部门",
    dataIndex: "depart",
    width: 150,
  },
  {
    title: "姓名",
    dataIndex: "name",
    width: 100,
  },
  {
    title: "职责",
    dataIndex: "duty",
    width: 230,
  },
  {
    title: "邮箱",
    dataIndex: "email",
    width: 200,
  },
  {
    title: "手机号",
    dataIndex: "phone",
    width: 130,
  },
];

export const BOOKLIST = [
  // {
  //   title: "战略运营篇",
  //   img: require("../assets/imgs/Book/book_1.png"),
  //   bg: require("../assets/imgs/Book/bg_1.png"),
  //   link: "https://static2.risfond.com//hrsop/onlineOpening/2023/202305/20230524/20230524_184624547288232_战略运营篇.pdf",
  // },
  {
    title: "集团行政篇",
    img: require("../assets/imgs/Book/book_7.png"),
    bg: require("../assets/imgs/Book/bg_7.png"),
    link: "https://static2.risfond.com//hrsop/onlineOpening/2023/202305/20230524/20230524_184536457409765_集团行政篇.pdf",
  },
  {
    title: "集团法务篇",
    img: require("../assets/imgs/Book/book_2.png"),
    bg: require("../assets/imgs/Book/bg_2.png"),
    link: "https://static2.risfond.com//hrsop/onlineOpening/2023/202305/20230524/20230524_184419114791550_集团法务篇.pdf",
  },
  {
    title: "集团财务篇",
    img: require("../assets/imgs/Book/book_3.png"),
    bg: require("../assets/imgs/Book/bg_3.png"),
    link: "https://static2.risfond.com//hrsop/onlineOpening/2024/202406/20240613/20240613_112609797574942_集团财务篇.pdf",
  },
  {
    title: "客户运营篇",
    img: require("../assets/imgs/Book/book_5.png"),
    bg: require("../assets/imgs/Book/bg_5.png"),
    link: "https://static2.risfond.com//hrsop/onlineOpening/2024/202406/20240625/20240625_154427106522142_客户运营篇.pdf",
  },
  {
    title: "集团人力篇",
    img: require("../assets/imgs/Book/book_4.png"),
    bg: require("../assets/imgs/Book/bg_4.png"),
    link: "https://static2.risfond.com//hrsop/onlineOpening/2023/202305/20230524/20230524_184438187882144_集团人力篇.pdf",
  },
  {
    title: "集团市场篇",
    img: require("../assets/imgs/Book/book_6.png"),
    bg: require("../assets/imgs/Book/bg_6.png"),
    link: "https://static2.risfond.com//hrsop/onlineOpening/2023/202305/20230524/20230524_184501771265366_集团市场篇.pdf",
  },
];

export const PLAINOPTIONS = [
  "公章",
  "法人章",
  "合同章",
  "发票章",
  "财务章",
  "营业执照正本",
  "营业执照副本",
  "法人身份证",
  "股东身份证(Lisa)",
  "集团公司章程",
];
// 资料及用印
export const SEALOPTIONS = [
  "地址变更",
  "股权变更",
  "名称变更",
  "注册资本变更",
  "营业范围变更",
  "法人、负责人变更",
];
